module.exports = __webpack_public_path__ + "static/media/Internationalcase5.8e77100d.png";